/**
 * Полоса вкладок ДК (вынесено из DcGridScreen.tsx 29.10 — экран заморожен рэтчетом, а вкладке «Новый год» нужно место).
 * Порядок — решение владельца 29.10: «Новый год» второй, сразу за сеткой; остальные не переставляем.
 */
import type { ComponentType, SVGProps } from "react";
import { IcGrid, IcNy, IcLeads, IcCancel, IcMirkv, IcBez, IcMoney, IcClients, IcCommerce } from "./dcIcons";
import css from "../DcGridScreen.module.css";

export type DcView = "grid" | "ny" | "leads" | "cancel" | "mirkv" | "bez" | "money" | "clients" | "commerce";

export const DC_TABS: { id: DcView; label: string; Icon: ComponentType<SVGProps<SVGSVGElement>> }[] = [
  { id: "grid", label: "Сетка", Icon: IcGrid },
  { id: "ny", label: "Новый год", Icon: IcNy },
  { id: "leads", label: "Лиды", Icon: IcLeads },
  { id: "cancel", label: "Отмены", Icon: IcCancel },
  { id: "mirkv", label: "Мир Кв", Icon: IcMirkv },
  { id: "bez", label: "БЕЗ", Icon: IcBez },
  { id: "money", label: "Money", Icon: IcMoney },
  { id: "clients", label: "Клиенты", Icon: IcClients },
  { id: "commerce", label: "Юнифанс", Icon: IcCommerce },
];

/* ── Section-tab strip (screen-02/06 эталон): icon-only inactive, active shows
 * the word. Лиды carries a pink count-pill. ──────────────────────────────── */
export function DcSecNav({ view, onChange, leadCount }: { view: DcView; onChange: (v: DcView) => void; leadCount: number }) {
  return (
    <nav className={css.secNav}>
      {DC_TABS.map(({ id, label, Icon }) => {
        const active = view === id;
        const pill = id === "leads" && leadCount > 0 ? leadCount : null;
        return (
          <button
            key={id}
            type="button"
            className={`${css.snav} ${active ? css.snavActive : ""}`}
            aria-label={label}
            aria-current={active ? "page" : undefined}
            onClick={() => onChange(id)}
          >
            <span className={css.snavIcon}><Icon aria-hidden="true" /></span>
            <span className={css.snavWord}>{label}</span>
            {pill != null ? <span className={css.snavPill}>{pill}</span> : null}
          </button>
        );
      })}
    </nav>
  );
}
